var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSendBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1579_216685)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1579_216685)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 31.5,
    r: 30.5,
    fill: "url(#paint0_linear_1579_216685)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.79 19.7732L46.86 29.8502C47.073 29.9519 47.2528 30.1118 47.3787 30.3114C47.5046 30.511 47.5714 30.7422 47.5714 30.9782C47.5714 31.2142 47.5046 31.4454 47.3787 31.645C47.2528 31.8446 47.073 32.0045 46.86 32.1062L25.79 42.1832C25.574 42.2866 25.3329 42.3259 25.0952 42.2962C24.8576 42.2665 24.6334 42.1692 24.4495 42.0158C24.2656 41.8625 24.1296 41.6595 24.0577 41.431C23.9858 41.2026 23.9811 40.9583 24.044 40.7272L26.152 32.9992C26.1779 32.9045 26.231 32.8195 26.3048 32.7547C26.3786 32.69 26.4698 32.6484 26.567 32.6352L36.777 31.2482C36.8197 31.2421 36.8601 31.2251 36.8943 31.1988C36.9284 31.1726 36.9552 31.1379 36.972 31.0982L36.99 31.0362C36.9979 30.9804 36.9867 30.9235 36.9582 30.8748C36.9297 30.8262 36.8856 30.7886 36.833 30.7682L36.778 30.7532L26.578 29.3662C26.481 29.3528 26.39 29.3111 26.3164 29.2464C26.2427 29.1817 26.1898 29.0968 26.164 29.0022L24.044 21.2302C23.9808 20.9991 23.9854 20.7546 24.0571 20.526C24.1289 20.2974 24.2649 20.0942 24.4489 19.9407C24.6329 19.7871 24.8571 19.6897 25.0949 19.66C25.3327 19.6303 25.574 19.6696 25.79 19.7732Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1579_216685",
    x: 0,
    y: 0,
    width: 71,
    height: 71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1579_216685"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1579_216685"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1579_216685"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0 0 0 0 0 0.282353 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1579_216685",
    result: "effect2_dropShadow_1579_216685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1579_216685",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1579_216685",
    x: 3.74227,
    y: 1,
    width: 63.5155,
    height: 63.5155,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.25773
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.628866
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.14902 0 0 0 0 0.427451 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1579_216685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1579_216685",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1579_216685",
    x1: 35.5,
    y1: 62,
    x2: 35.5,
    y2: 0.999997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#570280"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSendBtn);
export default __webpack_public_path__ + "static/media/message-send-btn.581e8a1c76c43e095ddecc9cb95f83af.svg";
export { ForwardRef as ReactComponent };